
  // export const apiUrl = 'https://project.magnumsolusion.co.id:5555'; 

 //   export const apiUrl = 'http://localhost:5001'; 
// export const apiUrl = 'http://10.5.8.223:5685'; 
// export const apiUrl = 'http://app.magnumsolusion.co.id:5685'; 
// export const apiUrl = 'http://localhost:5001'; 
 // export const apiUrl = 'https://app.magnumsolusion.co.id:5001'; 
 //export const apiUrl2 = 'https://10.5.8.223:5678'; 
 //export const apiUrl2 = 'https://app.magnumsolusion.co.id:5678'; 
 export const apiUrl = 'https://project.personaldev.my.id'; 
 export const apiUrl2 = 'http://localhost:5678'; 
 export const apiUrlChat = 'http://localhost:3000'; 
